<template>
  <div class="alert alert-custom alert-notice fade show alert-shadow" :class="[`alert-${variant}`]" role="alert">
    <div class="alert-icon" v-if="icon"><i class="fa" :class="icon"></i></div>
    <div class="alert-text">
      <h4 v-if="title" class="alert-heading mb-0">{{ title }}</h4>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    icon: String,
    variant: {
      type: String,
      default: "light-primary",
    },
  },
};
</script>

<style scoped>
.alert.alert-custom {
  padding: 1rem 1.5rem;
}

.alert.alert-custom .alert-icon i {
  font-size: 1.75rem;
}
</style>
